import { useState } from "react";

import { Flex, Paper } from "@mantine/core";

import {
  NEWBORN_POSTPARTUM_FLOWSHEET_MENU_BUTTONS,
  NEWBORN_POSTPARTUM_FLOWSHEET_QUICK_BUTTONS,
} from "@/encounters/components/EncounterLabor/constants/postpartum-flowsheets";
import NewbornPostpartumFlowsheetTable from "@/encounters/components/EncounterLabor/EncounterLaborPostpartum/NewbornPostpartum/NewbornTable";
import PostpartumFlowsheetHeader from "@/encounters/components/EncounterLabor/EncounterLaborPostpartum/PostpartumHeader/PostpartumFlowsheetHeader";
import { usePostpartumObservations } from "@/encounters/components/EncounterLabor/hooks/usePostpartumObservations";

interface NewbornPostpartumProps {
  encounterId: string;
  clientId: string;
  onBirthRefresh?: (isRetry?: boolean) => Promise<void>;
  onBirthCreate: (birthDateTime: string) => void;
  isViewOnly: boolean;
}

export default function NewbornPostpartum({
  encounterId,
  clientId,
  onBirthRefresh,
  onBirthCreate,
  isViewOnly,
}: NewbornPostpartumProps) {
  const [showNumbersOnly, setShowNumbersOnly] = useState(false);
  const { refreshObservations } = usePostpartumObservations(encounterId, clientId);

  return (
    <Flex bg="white.0" align="center" justify="center" direction="column">
      <Paper py="lg" w="97%" radius="xl" bg="white.0">
        <PostpartumFlowsheetHeader
          clientId={clientId}
          isViewOnly={isViewOnly}
          encounterId={encounterId}
          onRefresh={refreshObservations}
          showNumbersOnly={showNumbersOnly}
          title="Newborn Postpartum Flow Sheet"
          setShowNumbersOnly={setShowNumbersOnly}
          menuButtons={NEWBORN_POSTPARTUM_FLOWSHEET_MENU_BUTTONS}
          quickButtons={NEWBORN_POSTPARTUM_FLOWSHEET_QUICK_BUTTONS}
        />
        <NewbornPostpartumFlowsheetTable
          clientId={clientId}
          isViewOnly={isViewOnly}
          encounterId={encounterId}
          showNumbersOnly={showNumbersOnly}
        />
      </Paper>
    </Flex>
  );
}
